import { ICSSInJSStyle, ThemePrepared } from '@fluentui/react-northstar';
import memoizee from 'memoizee';
import { Paths } from './routes';

export interface IAppStyles {
  rootFlex: ICSSInJSStyle;
  provider: ICSSInJSStyle;
}

const getAppStylesRaw = (theme: ThemePrepared): IAppStyles => {
  let backgroundColor = 'transparent';
  if (process.env.REACT_APP_CLIENT_SDK_MODE === 'fake-client-sdk') {
    // Setting a background by default when running in e2e mode.
    // This will get compiled away at build time.
    backgroundColor = theme.siteVariables.colorScheme.default.background;
  }

  if (
    window.location.hash?.endsWith(Paths.ChannelTabRemove) ||
    window.location.hash?.endsWith(Paths.ChannelTabConfig) ||
    // Our default route ends goes to ChannelTabConfig, so this applies the right styles in that case
    window.location?.hash === ''
  ) {
    backgroundColor = theme.siteVariables.colorScheme.default.background;
  }

  const rootFlex = {
    minWidth: '100%',
    minHeight: '100%',
    flex: 1,
    backgroundColor
  };

  return {
    rootFlex,
    provider: {
      display: 'flex',
      flexFlow: 'column',
      minHeight: '100%',
      '> *': {
        'flex-grow': 1
      },
      backgroundColor
    }
  };
};

export const getAppStyles = memoizee(getAppStylesRaw);
